'use client'

import { motion } from 'framer-motion'
import { Mail } from 'lucide-react'
import { SubscribeForm } from '@/components/newsletter/SubscribeForm'

export function NewsletterSection() {
  return (
    <section className="py-16 md:py-24">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-primary via-primary-600 to-accent-purple p-8 md:p-16"
        >
          {/* Background Pattern */}
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-0 left-0 w-64 h-64 bg-white rounded-full blur-3xl" />
            <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl" />
          </div>

          <div className="relative z-10 max-w-3xl mx-auto text-center">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-white/20 mb-6">
              <Mail className="w-8 h-8 text-white" />
            </div>
            
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Join 1,000+ Knowledge Seekers
            </h2>
            
            <p className="text-lg text-white/90 mb-8 max-w-2xl mx-auto">
              Get weekly insights, exclusive content, and the latest articles delivered straight to your inbox. 
              No spam, unsubscribe anytime.
            </p>

            <SubscribeForm
              className="max-w-md mx-auto"
              placeholder="Enter your email address"
              submitLabel="Subscribe"
              source="homepage"
            />

            <p className="text-sm text-white/70 mt-4">
              By subscribing, you agree to our Privacy Policy and consent to receive updates.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  )
}
